import clsx from "clsx";
import { labelStyle, inputStyle } from "..";

export default function PreviewImg({ imgURL, onImgURL, imgALT, onAlt }) {
  return (
    <>
      <label className={labelStyle}>Preview Image</label>
      <div className="flex items-center">
        <div className="text-sm w-[50px]">URL</div>
        <input
          className={inputStyle}
          value={imgURL}
          onChange={(e) => onImgURL(e.target.value)}
        />
      </div>
      <div className="flex items-center">
        <div className="text-sm w-[50px]">ALT</div>
        <input
          className={inputStyle}
          value={imgALT}
          onChange={(e) => onAlt(e.target.value)}
        />
      </div>
      <img src={imgURL} alt={imgALT} className={previewImgStyle} />
    </>
  );
}

const previewImgStyle = clsx(
  "h-[300px] border-2 border-dotted rounded-md my-4"
);
